import { render, staticRenderFns } from "./SendViaPeppolModal.vue?vue&type=template&id=6b759d70&scoped=true"
import script from "./SendViaPeppolModal.vue?vue&type=script&lang=ts"
export * from "./SendViaPeppolModal.vue?vue&type=script&lang=ts"
import style0 from "./SendViaPeppolModal.vue?vue&type=style&index=0&id=6b759d70&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b759d70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b759d70')) {
      api.createRecord('6b759d70', component.options)
    } else {
      api.reload('6b759d70', component.options)
    }
    module.hot.accept("./SendViaPeppolModal.vue?vue&type=template&id=6b759d70&scoped=true", function () {
      api.rerender('6b759d70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SendViaPeppolModal.vue"
export default component.exports